import { CategoriesResponse } from '../types/types'
export const formatSelectedCategories = (
  selected: boolean[],
  categories?: CategoriesResponse
): string => {
  if (!categories?.length || !selected.length) return '-'
  if (categories?.length !== selected.length) {
    console.warn('Длина массивов категорий и флагов не совпадает')
    return '-'
  }

  return categories
    .filter((_, index) => selected[index])
    .map((category) => category.name)
    .join(', ')
}
